import { Link, useParams, useNavigate } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";
import DeleteModalSnapp from "../../../components/deleteModal/DeleteModalSnapp";

const ToppingCategories = () => {
  const [loading, setLoading] = useState(false);
  const { branchId, unitId } = useParams();
  const navigate = useNavigate();
  const [pageTitle, setPageTitle] = useState("");
  const [gridData, setGridData] = useState([]);
  const [menuCategories, setMenuCategories] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showInquiryModal, setShowInquiryModal] = useState(false);

  const [showModalSearch, setShowModalSearch] = useState(true);
  const [snappSecurity, setSnappSecurity] = useState({
    vendorCode: "",
    snappToken: "",
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    menuCategoryId: 0,
    title: "",
    orderIndex: 0,
    active: false,
    minSelection: 1,
    maxSelection: 1,
    position: 0,
    snappGroupSyncId: 0,
    saleUnitId: unitId,
    branchId: branchId,
    vendorCode: "",
    snappToken: "",
  });

  const [filterData, setFilterData] = useState({
    branchId: branchId,
    unitId: unitId,
    part: 1,
    size: 20,
    title: "",
    total: 0,
    parts: 0,
  });

  const [categroyFilter, setCategroyFilter] = useState({
    branchId: branchId,
    unitId: unitId,
    contentType: 3,
    part: 1,
    size: 500,
    title: "",
    total: 0,
    parts: 0,
  });

  const [snappToppingRecords, setSnappToppingRecords] = useState({
    toppingGroups: [],
    productToppings: [],
    normalData: [],
    visiblity: false,
  });

  const [toppingItems, setToppingItems] = useState([]);

  const getSnappData = async () => {
    const response = await apiMethod.getDierctAllToppings({
      branchId: branchId,
      snappToken: snappSecurity.snappToken,
    });

    if (!methods.showApiErrors(response)) return false;

    snappToppingRecords.toppingGroups = response.data.toppingGroups;
    snappToppingRecords.productToppings = response.data.productToppings;
    snappToppingRecords.normalData = response.normalData;
    snappToppingRecords.visiblity = true;
    setSnappToppingRecords({ ...snappToppingRecords });
  };

  const setFromSnapp = (item) => {
    formModel.snappGroupSyncId = item.id;
    setFormModel({ ...formModel });

    snappToppingRecords.visiblity = false;
    setSnappToppingRecords({ ...snappToppingRecords });
  };

  const getGridData = async (showLoading) => {
    if (showLoading) setLoading(true);
    const response = await apiMethod.getToppingCategories(
      filterData.branchId,
      filterData.unitId,
      filterData.size,
      filterData.part,
      filterData.title
    );
    if (showLoading) setLoading(false);
    if (methods.showApiErrors(response)) {
      filterData.total = response.total;
      filterData.parts = methods.calcPageParts(response.total, filterData.size);
      setFilterData({ ...filterData });
      setGridData(response.data);
    }
  };

  const getPageTitle = async () => {
    const response = await apiMethod.getUnitInfo(unitId);
    if (!methods.showApiErrors(response)) return false;

    setPageTitle(response.data.title);
  };

  const findMenuCategories = async (filterMode) => {
    const response = await apiMethod.findMenuCategoriesForSnapp(
      categroyFilter.branchId,
      categroyFilter.unitId,
      categroyFilter.contentType,
      filterMode,
      categroyFilter.size,
      categroyFilter.part,
      categroyFilter.title
    );
    if (methods.showApiErrors(response)) {
      categroyFilter.total = response.total;
      categroyFilter.parts = methods.calcPageParts(
        response.total,
        categroyFilter.size
      );
      setCategroyFilter({ ...categroyFilter });
      setMenuCategories(response.data);
    }
  };

  const setSnappToken = async () => {
    const response = await apiMethod.getSnappToken(branchId, unitId);
    if (!methods.showApiErrors(response)) return false;
    snappSecurity.snappToken = response.data.token;
    snappSecurity.vendorCode = response.data.clientId;
    setSnappSecurity({ ...snappSecurity });
  };

  const mapModel = (model) => {
    formModel.id = model.id;
    formModel.title = model.title;
    formModel.menuCategoryId = model.menuCategoryId;
    formModel.minSelection = model.minSelection;
    formModel.maxSelection = model.maxSelection;
    formModel.position = model.position;
    formModel.saleUnitId = model.saleUnitId;
    formModel.branchId = model.branchId;
    formModel.vendorCode = snappSecurity.vendorCode;
    formModel.snappToken = snappSecurity.snappToken;
    setFormModel({ ...formModel });
  };

  const initData = async () => {
    setLoading(true);
    await getGridData(false);
    await getPageTitle();
    await setSnappToken();
    findMenuCategories(false);
    setLoading(false);
  };

  useEffect(() => {
    initData();
  }, [branchId, unitId]);

  const resetForm = () => {
    setFormModel({
      id: 0,
      menuCategoryId: 0,
      title: "",
      categoryTitle: "",
      orderIndex: 0,
      active: false,
      minSelection: 1,
      maxSelection: 1,
      position: 0,
      saleUnitId: unitId,
      branchId: branchId,
      vendorCode: formModel.vendorCode,
      snappToken: formModel.snappToken,
    });
    setShowModal(false);
    setShowDeleteModal(false);
    setShowModalSearch(true);
  };

  const editItem = async (id) => {
    setLoading(true);
    await findMenuCategories(false);
    const response = await apiMethod.getSnappCategoryInfo(id);
    if (methods.showApiErrors(response)) {
      mapModel(response.data);
      setShowModalSearch(false);
      setShowModal(true);
    }
    setLoading(false);
  };

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title))
      errors.push(".عنوان باید مقدار داشته باشد");

    if (formModel.menuCategoryId === 0)
      errors.push(".دسته منو باید مقدار داشته باشد");

    // if (formModel.maxSelection === 0)
    //     errors.push('.حداکثر انتخاب باید مقدار داشته باشد');

    // if (formModel.minSelection === 0)
    //     errors.push('.حداقل انتخاب باید مقدار داشته باشد');

    if (formModel.position === 0)
      errors.push(".ترتیب نمایش باید مقدار داشته باشد");

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const normalizeRequest = () => {
    formModel.snappToken = snappSecurity.snappToken;
    formModel.vendorCode = snappSecurity.vendorCode;
    setFormModel({ ...formModel });
  };

  const createItem = async () => {
    normalizeRequest();
    if (!validForm()) return false;

    setLoading(true);

    const resp = await apiMethod.createToppingCategory(formModel);

    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }

    await getGridData();
    setLoading(false);
    setShowModal(false);
  };

  const resetCategoryFilters = () => {
    categroyFilter.branchId = branchId;
    categroyFilter.unitId = unitId;
    categroyFilter.title = "";
    setCategroyFilter({ ...categroyFilter });
  };

  const openItemForm = async (loadShow) => {
    if (loadShow) setLoading(true);
    await findMenuCategories(true);
    resetForm();
    setShowModal(true);
    if (loadShow) setLoading(false);
  };

  const searchCategoryItem = async () => {
    setLoading(true);
    await findMenuCategories(true);
    setLoading(false);
  };

  const clearCategorySearch = async () => {
    setLoading(true);
    resetCategoryFilters();
    await findMenuCategories(true);
    setLoading(false);
  };

  const resetFilters = () => {
    filterData.branchId = branchId;
    filterData.unitId = unitId;
    filterData.title = "";
    setFilterData({ ...filterData });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const syncSnappData = async (toppingCatId) => {
    var resp = await apiMethod.syncCategoryToppings({
      toppingCategoryId: toppingCatId,
      snappToken: snappSecurity.snappToken,
      vendorCode: snappSecurity.vendorCode,
    });
    if (methods.showApiErrors(resp))
      methods.showSuccesses(["هماهنگ سازی موفق داده ها با اسنپ"]);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterData.parts < filterData.part + 1) {
        return false;
      }
      callPager(filterData.part + 1);
    } else {
      if (filterData.part === 1) {
        return false;
      }
      callPager(filterData.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterData.part = i;
    setFilterData({ ...filterData });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterData.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterData.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const movePagerPartCategory = (isForward) => {
    if (isForward) {
      if (categroyFilter.parts < categroyFilter.part + 1) {
        return false;
      }
      callPager(categroyFilter.part + 1);
    } else {
      if (categroyFilter.part === 1) {
        return false;
      }
      callPager(categroyFilter.part - 1);
    }
  };

  const callPagerCategory = async (i) => {
    setLoading(true);
    categroyFilter.part = i;
    setCategroyFilter({ ...categroyFilter });
    await findMenuCategories();
    setLoading(false);
  };

  const makePagerItemsCategory = () => {
    let pages = [];
    for (let i = 1; i <= categroyFilter.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            categroyFilter.part === i
              ? "page-item active mx-1"
              : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPagerCategory(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const switchToAllCategoriesView = () => {
    setShowModalSearch(true);
  };

  const openNewForm = async () => {
    resetForm();
    setShowModal(true);
  };

  const closeModal = () => {
    resetForm();
    setShowModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَSanpToDelete = (snap) => {
    setFormModel(snap);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeSnappCategory(formModel.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();

      setShowDeleteModal(false);
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const setMenuCategory = (category) => {
    formModel.title = category.title;
    formModel.menuCategoryId = category.id;
    setFormModel(formModel);
    setShowModalSearch(false);
  };

  const openInquiryModal = async () => {
    setLoading(true);
    await getSnappData();
    setShowInquiryModal(true);
    setLoading(false);
  };

  const renderModule = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div>
              <Link
                to={`/sale/${branchId}/snappManager/SnappMenuGroups/${unitId}`}
                className="d-none d-lg-block text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/sale/${branchId}/snappManager`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                {pageTitle} / دسته‌بندی‌های تاپینگ
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>{pageTitle} / دسته‌بندی‌های تاپینگ</p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-12 col-md-6 col-lg-4">
                    <label htmlFor="funit" className="form-label">
                      عنوان
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterData.title}
                        onChange={(e) => {
                          filterData.title = e.target.value;
                          setFilterData({ ...filterData });
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-8 text-end">
                    <div className="createButton">
                      <button
                        onClick={() => {
                          openInquiryModal();
                        }}
                        className="btn btn-outline-purple custome-btn ms-3"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          استعلام تاپینگ در اسنپ
                        </span>
                      </button>
                      <button
                        onClick={() => {
                          openItemForm(true);
                        }}
                        className="btn btn-outline-purple custome-btn"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          ایجاد دسته‌بندی
                        </span>{" "}
                        <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md ">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان در اسنپ</th>
                      <th scope="col vertical-center">عنوان در شعبه</th>
                      <th scope="col vertical-center">شماره ترتیب</th>
                      <th scope="col vertical-center">محدودیت ها</th>
                      <th scope="col vertical-center">وضعیت اتصال</th>
                      <th scope="col vertical-center">تاپینگ ها</th>
                      <th scope="col vertical-center" width="100px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(filterData.part - 1) * filterData.size + index + 1}
                        </th>
                        <td>{item.title}</td>
                        <td>{item.categoryTitle}</td>
                        <td>{item.position}</td>
                        <td>
                          <span>حداقل انتخاب:</span>{" "}
                          <span>{item.minSelection}</span> <br />
                          <span>حداکثر انتخاب:</span>{" "}
                          <span>{item.maxSelection}</span>
                        </td>
                        <td>
                          {item.snappGroupSyncId > 0 && (
                            <>
                              <span className="text-success">متصل</span>
                            </>
                          )}
                          {item.snappGroupSyncId === 0 && (
                            <>
                              <span className="text-danger">عدم اتصال</span>
                            </>
                          )}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-purple"
                            onClick={() => {
                              navigate(
                                `/sale/${branchId}/snappManager/${unitId}/SnappToppings/${item.id}`
                              );
                            }}
                          >
                            تاپینگ ها
                            <span className="badge tablebadge ms-1">
                              {item.menuCount}
                            </span>
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => editItem(item.id)}
                            className="btn btn-sm btn-outline-purple"
                            type="button"
                          >
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => selectَSanpToDelete(item)}
                            className="btn btn-sm btn-outline-danger me-2"
                            type="button"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                          <button
                            onClick={() => syncSnappData(item.id)}
                            className="btn btn-sm btn-outline-info"
                            type="button"
                          >
                            <i className="bi bi-arrow-repeat"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterData.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const Modal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد / ویرایش دسته تاپینگ</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  closeModal();
                }}
              ></button>
            </div>
            <div className="modal-body">
              {showModalSearch && (
                <>
                  <div className="col-md-8 col-lg-6">
                    <label htmlFor="funit" className="form-label">
                      جستجو در دسته‌بندی‌ها
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={categroyFilter.title}
                        onChange={(e) => {
                          categroyFilter.title = e.target.value;
                          setCategroyFilter({ ...categroyFilter });
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={searchCategoryItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearCategorySearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="border rounded mt-4">
                    <p className="bg-light rounded-top p-3">
                      انتخاب دسته‌بندی شعبه
                    </p>
                    <div className="table-responsive saletable m-3">
                      <table className="table table-striped table-md align-middle">
                        <thead className="">
                          <tr>
                            <th scope="col vertical-center" width="20px">
                              ردیف
                            </th>
                            <th scope="col vertical-center">عنوان</th>
                            <th scope="col vertical-center">دسته بالاتر</th>
                            <th scope="col vertical-center" width="50px">
                              عملیات
                            </th>
                          </tr>
                        </thead>
                        <tbody className="">
                          {menuCategories.map((item, index) => (
                            <tr key={item.id}>
                              <th scope="row">
                                {(categroyFilter.part - 1) *
                                  categroyFilter.size +
                                  index +
                                  1}
                              </th>
                              <td>{item.title}</td>
                              <td>{item.parentTitle}</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-purple"
                                  onClick={() => setMenuCategory(item)}
                                >
                                  افزودن
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {categroyFilter.parts > 1 && (
                        <nav
                          aria-label="Page navigation example"
                          className="mt-5"
                        >
                          <ul className="pagination justify-content-center">
                            <li className="page-item mx-1">
                              <a
                                className="page-link circular-pagination"
                                onClick={() => {
                                  movePagerPartCategory(false);
                                }}
                              >
                                <i className="bi bi-chevron-compact-right"></i>
                              </a>
                            </li>
                            {makePagerItemsCategory()}
                            <li className="page-item mx-1">
                              <a
                                className="page-link circular-pagination"
                                onClick={() => {
                                  movePagerPartCategory(true);
                                }}
                              >
                                <i className="bi bi-chevron-compact-left"></i>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      )}
                    </div>
                  </div>
                </>
              )}
              {!showModalSearch && (
                <>
                  <div className="mb-4">
                    <Link
                      onClick={switchToAllCategoriesView}
                      className="link back-link"
                    >
                      <span>
                        <img src={back} className="" alt="return" />
                      </span>
                      بازگشت
                    </Link>
                  </div>
                  <div className="row mb-3">
                    <div className="col-6">
                      <button
                        onClick={() => {
                          getSnappData();
                        }}
                        type="button"
                        className="btn btn-sm btn-outline-purple"
                      >
                        انتخاب دسته موجود در اسنپ
                      </button>
                    </div>
                  </div>
                  {snappToppingRecords.visiblity && (
                    <div className="snapp-records mb-4">
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>عنوان</th>
                              <th>شناسه</th>
                              <th>آیتم ها</th>
                              <th width="130px">انتخاب</th>
                            </tr>
                          </thead>
                          <tbody>
                            {snappToppingRecords.toppingGroups.map((item) => (
                              <tr key={item.id}>
                                <td>{item.title}</td>
                                <td>{item.id}</td>
                                <td>
                                  <button
                                    onClick={() => {
                                      if (
                                        toppingItems.length == 0 &&
                                        item.toppings.length > 0
                                      )
                                        setToppingItems(item.toppings);
                                      else if (
                                        item.toppings.length > 0 &&
                                        toppingItems[0].id !=
                                          item.toppings[0].id
                                      )
                                        setToppingItems(item.toppings);
                                      else setToppingItems([]);
                                    }}
                                    type="button"
                                    className="btn btn-outline-purple"
                                  >
                                    آیتم ها
                                    <span className="badge bg-warning">
                                      {item.toppings.length}
                                    </span>
                                  </button>
                                </td>
                                <td>
                                  <div className="text-center">
                                    <button
                                      onClick={() => {
                                        setFromSnapp(item);
                                      }}
                                      className="btn btn-purple btn-sm"
                                    >
                                      انتخاب دسته
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {toppingItems.length > 0 && (
                          <table className="table table-bordered mt-4">
                            <tbody>
                              <tr>
                                <td colSpan={3}>
                                  <h6 className="text-center">آیتم های دسته</h6>
                                </td>
                              </tr>
                              <tr>
                                <td>عنوان</td>
                                <td>قیمت</td>
                                <td>شناسه</td>
                              </tr>
                              {toppingItems.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.title}</td>
                                  <td>{methods.addNumSeperator(item.price)}</td>
                                  <td>{item.id}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="row g-3" autoComplete="off">
                    <div className="col-md-4">
                      <label htmlFor="title" className="form-label">
                        عنوان
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="title"
                        name="title"
                        value={formModel.title}
                        onChange={(e) => {
                          setFormModel({ ...formModel, title: e.target.value });
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <label
                        htmlFor="ddlcategory"
                        className="form-label required-label"
                      >
                        دسته متصل
                      </label>
                      <select
                        id="ddlcategory"
                        className="form-select"
                        aria-label="Default select example"
                        value={formModel.menuCategoryId}
                        onChange={(e) =>
                          setFormModel({
                            ...formModel,
                            menuCategoryId: e.target.value,
                          })
                        }
                      >
                        {menuCategories.map((item) => (
                          <option value={item.id} key={item.id}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="position" className="form-label">
                        شماره ترتیب نمایش
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="position"
                        value={formModel.position}
                        onChange={(e) => {
                          formModel.position = parseInt(e.target.value);
                          setFormModel({ ...formModel });
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="minSelection" className="form-label">
                        حداقل انتخاب
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="minSelection"
                        value={formModel.minSelection}
                        onChange={(e) => {
                          formModel.minSelection = parseInt(e.target.value);
                          setFormModel({ ...formModel });
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="maxSelection" className="form-label">
                        حداکثر انتخاب
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="maxSelection"
                        value={formModel.maxSelection}
                        onChange={(e) => {
                          formModel.maxSelection = parseInt(e.target.value);
                          setFormModel({ ...formModel });
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer col-12">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>

              <button
                type="button"
                onClick={() => {
                  createItem();
                }}
                className="btn custome-btn btn-purple w-25 "
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const InquiryModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showInquiryModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">استعلام تاپینگ ها در اسنپ</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setShowInquiryModal(false);
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="snapp-records mb-4">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>منو</th>
                        <th>شناسه منو</th>
                        <th>تاپینگ</th>
                        <th>شناسه تاپینگ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {snappToppingRecords.normalData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.snappMenuTitle}</td>
                          <td>{item.menuId}</td>
                          <td>{item.toppingTitle}</td>
                          <td>{item.toppingId}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="modal-footer col-12">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={() => {
                  setShowInquiryModal(false);
                }}
              >
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderModule()}
      {showModal && Modal()}
      {showInquiryModal && InquiryModal()}
      {showDeleteModal && (
        <DeleteModalSnapp
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"دسته‌بندی"}
        />
      )}
    </>
  );
};
export default ToppingCategories;
